// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.

export const ADD_BREADCRUMB = "ADD_BREADCRUMB";
export const REMOVE_BREADCRUMB = "REMOVE_BREADCRUMB";
